export default {
  institutional: {
    benefits: 'Benefits',
    talkToUs: 'Talk to us.',
    modalTitle: 'Get In Touch',
    getInTouch: 'Get in touch',
    learnMore: 'Ready to learn More?',
    trustedByTheBest: 'Trusted by the best',
    heroTitle: 'Truly On-Chain Institutional Finance',
    allRightsReserved: 'Injective Labs. All Rights Reserved.',
    modalDescription: 'Connect directly with the Helix Institutional team.',
    whyFinancialInstitutionsChooseHelix:
      'Why financial institutions choose Helix',
    heroSubtitle:
      'Engage with unlimited crypto assets, perpetuals, and structured products on the only fully decentralized network.',

    permisionedMarketsTitle: 'Permissioned Markets',
    permisionedMarketsBody:
      'Helix uniquely provides a gateway to institutional grade permissioned markets, enabling you to seamlessly interact with professionally vetted counterparties.',
    multiAssetSupportTitle: 'Multi-asset Support',
    multiAssetSupportBody:
      'Access a diverse array of on-chain assets, derivatives, and structured products across multiple blockchain networks.',
    onChainTransparencyTitle: 'On-chain Transparency',
    onChainTransparencyBody:
      'Maximize your security with the only platform where all transactions, trades, settlements and asset issuances occur fully on-chain.',
    fullyCompliantTitle: 'On-chain Transparency',
    fullyCompliantBody:
      'Maximize your security with the only platform where all transactions, trades, settlements and asset issuances occur fully on-chain.',
    instantSettlementTitle: 'Instant Settlement',
    instantSettlementBody:
      'Execute MEV resistant transactions that are manipulation proof with the fastest settlement times in the industry.',
    robustSecurityTitle: 'Robust Security',
    robustSecurityBody:
      'Utilize a non-custodial platform with the strictest security measures to ensure that your assets never leave your control.',
    superiorInfrastructureTitle: 'Superior Infrastructure',
    superiorInfrastructureBody:
      'Leverage Helix’s custom infrastructure designed to fit the needs of the most sophisticated financial institutions and traders.',

    form: {
      email: 'Email',
      company: 'Company',
      lastName: 'Last Name',
      firstName: 'First Name'
    }
  }
}
